import React, { useState, useEffect } from "react";
import { producaov2 as api } from "../../../services/apis";
import { Button, Dropdown } from "semantic-ui-react";
import { Container } from "./styles";
import AdminMenu from "../../../components/Admin/MenuDetalhes/AdminMenu";
import { AlunoSearchInput } from "../../../components/Admin/AlunoSearchInput";

export const MBAAtribuir = props => {
  const [selectedAluno, setSelectedAluno] = useState(null);
  const [selectedMBA, setSelectedMBA] = useState(null);

  const [mbas, setMbas] = useState([]);

  useEffect(() => {
    api.get("/admin/mba/list").then(response => setMbas(response.data));
  }, []);

  const handleSubmit = async () => {
    if (!selectedAluno || !selectedMBA) {
      swal("Por favor, preencha os dois campos", "", "error");
      return;
    }

    try {
      api
        .post("/admin/mba/create-from-molde", {
          user_id: selectedAluno,
          curso_id: selectedMBA,
        })
        .then(async () => {
          api
            .put("/admin/mba/check-courses", {
              user_id: selectedAluno,
              id_mba: selectedMBA,
            })
            .then(() => {
              swal("MBA liberado com sucesso", "", "success");
            })
            .catch(() => {
              swal(
                "o MBA foi liberado, porem houve um erro ao liberar os cursos",
                "",
                "error"
              );
            });

          const logs = {
            local: "/admin/mba/atribuir",
            texto: `Atribuiu o MBA (${selectedMBA}) para o aluno (${selectedAluno})`,
          };
          await api.post("system_logs", {
            acao: JSON.stringify(logs),
          });
        });
    } catch (error) {
      swal("Houve um erro ao liberar o MBA", "", "error");
      const logs = {
        local: "/admin/mba/atribuir",
        texto: `Tentou atribuir o MBA (${selectedMBA}) para o aluno (${selectedAluno}) - Erro: ${error}`,
      };
      await api.post("system_logs", {
        acao: JSON.stringify(logs),
      });
    }
  };

  return (
    <div style={{width: "100vw", paddingLeft:"250px"}}>
      <AdminMenu />
      <Container>
        <h1>Atribuir MBA</h1>

        <form>
          <AlunoSearchInput
            handleChange={evt => {
              setSelectedAluno(evt.id);
            }}
          />

          {mbas && (
            <Dropdown
              placeholder="Selecione um MBA"
              selection
              options={mbas.map(mba => ({
                key: mba.id_curso,
                text: mba.descricao,
                value: mba.id_curso,
              }))}
              onChange={(event, data) => {
                setSelectedMBA(data.value);
              }}
            />
          )}
        </form>
        <Button onClick={() => handleSubmit()}>Atribuir</Button>
      </Container>
    </div>
  );
};
